import { render, staticRenderFns } from "./DomainResponsibleList.vue?vue&type=template&id=d57cf15c&"
import script from "./DomainResponsibleList.vue?vue&type=script&lang=js&"
export * from "./DomainResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./DomainResponsibleList.vue?vue&type=style&index=0&id=d57cf15c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports